
jQuery(function () {
    $(".lpg-mobile-menu-data-top .menu-item-has-children>a, .lpg-mobile-menu-data-bottom .menu-item-has-children>a").on('click', function (e) {
        e.preventDefault();
        $(this).next('.sub-menu').slideToggle("slow", "linear");
        $(this).parent().toggleClass('open');
    });
});
